export enum AggregateFunctionApiEnum {
    SUM = 'SUM',
    AVG = 'AVG',
    MAX = 'MAX',
    MIN = 'MIN',
}
